import { FileViewController } from './file-view.controller';
import { FileViewProps } from './file-view.model';

const FileView = (props: FileViewProps): JSX.Element => {
  return <FileViewController {...props} />;
};
export default FileView;
